import { LoadingOutlined } from "@ant-design/icons";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import { lazy } from "react";
import { Route, Routes } from "react-router-dom";
import ApplicationRoutes from "./ApplicationRoutes.tsx";

import "./style.css";
import { Layout } from "../layout/Layout.tsx";

const Health = lazy(() => import("../pages/Shared/Health/HealthPage"));

const AllRoutes = () => {
  const AuthenticationRequiredRoutes = withAuthenticationRequired(ApplicationRoutes, {
    onRedirecting: () => (
      <div className="loading-full-screen">
        <LoadingOutlined style={{ fontSize: 44 }} spin />
      </div>
    ),
  });

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/health" element={<Health />} />
        <Route path="*" element={<AuthenticationRequiredRoutes />} />
      </Route>
    </Routes>
  );
};

export default AllRoutes;
